import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const TrendingContainer = ({ trending }) => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  if (!trending || trending.length === 0) return null; //. No render if no data

  //. Navigate to PropertyList with destination_id
  const handlePropertyClick = (propertyId) => {
  navigate(`/property/${propertyId}`);
};

  const badgeLabel = (badge) =>
    badge
      ? badge.discount_type === "percent"
        ? `${badge.discount_value}% OFF`
        : `₹${Math.round(badge.discount_value)} OFF`
      : null;


  return (
    <section className="trendingcontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="section-heading d-flex justify-content-between align-items-center"
              data-aos="zoom-in"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
            >
              <h2>Trending Getaways</h2>
              {/* Optionally add View All button here */}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12" data-aos="fade-up" data-aos-duration="500">
            <Swiper
              id="TrendingDeal"
              modules={[Navigation, Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              speed={700}
              spaceBetween={15}
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next-trending",
                prevEl: ".swiper-button-prev-trending",
              }}
              breakpoints={{
                100: { slidesPerView: 2.6, spaceBetween: 5 },
                321: { slidesPerView: 2.6, spaceBetween: 5 },
                574: { slidesPerView: 2.6, spaceBetween: 5 },
                768: { slidesPerView: 3.4, spaceBetween: 10 },
                992: { slidesPerView: 4.2, spaceBetween: 15 },
                1200: { slidesPerView: 4.6, spaceBetween: 20 },
                1400: { slidesPerView: 5, spaceBetween: 20 },
              }}
              loop={false}
            >
              {trending.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="trendingdealbx">
                    <div className="trendingdealimg">
                      <a href="#" style={{ cursor: "pointer" }}>
                        <img
                          src={item.image || "/guestlinkup/images/nhii.png"} //. fallback
                          alt={item.title}
                        />
                      </a>
                      {item.promo_badge && (
                        <span className="promo-badge">
                          <span className="promo-dot"></span>
                          {badgeLabel(item.promo_badge)}
                        </span>
                      )}
                      <div className="bsovrlay">
                        {/* <a href="#" className="bsview">
                          <i className="icon icon-search"></i>
                        </a> */}

                        <a
                          // href="#"
                          style={{ cursor: "pointer" }}
                          className="bsview"
                            onClick={() => handlePropertyClick(item.id)}
                        >
                          <i className="icon icon-search"></i>
                        </a>
                      </div>
                    </div>
                    <div className="trendingdealcontent">
                      <div className="w-100">
                        <h3 className="trending-name-clamp">
                          <a style={{ cursor: "pointer" }} onClick={() => handlePropertyClick(item.id)}>{item.trending_name}</a>
                        </h3>

                        <p>{item.location}</p>
                      </div>
                      <span className="startp">
                        <i className="fa fa-star"></i>
                        <span>{item.rating || "N/A"}</span>
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="swiper-nav">
              <div className="swiper-button-prev swiper-button-prev-trending"></div>
              <div className="swiper-button-next swiper-button-next-trending"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingContainer;
